import React from "react";
import { AOSProps } from "../../global/types";

export const Iconlist: React.FC = ({ children }) => {
  return <ul className="iconlist">{children}</ul>;
};

export const IconlistItem: React.FC = ({ children }) => {
  return <li>{children}</li>;
};

export const IconlistIcon: React.FC<AOSProps> = ({
  children,
  dataAos,
  dataAosDelay
}) => {
  return (
    <div
      className="iconlist__icon-wrapper"
      data-aos={dataAos}
      data-aos-delay={dataAosDelay}
    >
      <div className="iconlist__icon">{children}</div>
    </div>
  );
};

export const IconlistContent: React.FC<AOSProps> = ({
  children,
  dataAos,
  dataAosDelay
}) => {
  return (
    <div
      className="iconlist__content"
      data-aos={dataAos}
      data-aos-delay={dataAosDelay}
    >
      {children}
    </div>
  );
};
